import { Button } from "antd";
import AppTooltip from "./AppTooltip";

function AppButton({
  label,
  type,
  name,
  prefix,
  suffix,
  disabled,
  className = "",
  cursor,
  onClick,
  size,
  width,
  icon,
  tooltip,
  ...props
}) {
  const button = (
    <Button
      aria-label={label || tooltip}
      type={type}
      name={name}
      className={`common-btn ${className}`}
      disabled={disabled}
      cursor={cursor}
      onClick={onClick}
      size={size}
      width={width}
      icon={icon}
      {...props}
    >
      {prefix && <span className="btn-prefix">{prefix}</span>}
      {label}
      {suffix && <span className="btn-suffix">{suffix}</span>}
    </Button>
  );

  // Disabled elements swallow hover events, so a disabled button shows no
  // tooltip (accepted tradeoff — the "why disabled" hint is lost on disabled actions).
  if (tooltip && !disabled) {
    return <AppTooltip title={tooltip}>{button}</AppTooltip>;
  }
  return button;
}

export default AppButton;
